// removed by extract-text-webpack-plugin
module.exports = {"BotAvatar":"BotAvatar---3QaUz"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/shared-web/src/components/BotAvatar/style.styl
// module id = WJEK
// module chunks = 88